import React from "react";
import { MainReservationsPage } from "./MainReservationsPage";
import { ReservationProvider } from "@/contexts/ReservationContext";

export const ReservationsPage: React.FC = () => {
  return (
    <ReservationProvider>
      <MainReservationsPage />
    </ReservationProvider>
  );
};
